import React, { useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import useNebula from 'hooks/useNebula';
import AppContext from '../AppContext';

const styles = () => ({
  viz: {

  },
});

const BarGoals = ({
  classes,
}) => {
  const qlikApp = useContext(AppContext);

  const nebula = useNebula(qlikApp);
  const barGoalsRef = useRef();
  const barGoalsVizRef = useRef();

  useEffect(async () => {
    if (!nebula) return;

    barGoalsVizRef.current = await nebula.render({
      element: barGoalsRef.current,
      type: 'bar',
      fields: [
        {
          qDef: {
            qFieldDefs: [`=replace(class([minute_regulation],15
                ), '<= x <','-')`],
          },
        },
        {
          qDef: {
            qDef: '=Count(distinct goal_id)',
          },
        },
      ],
    });
  }, [nebula]);

  return (
    <>
      <div id="barGoalsViz" className={classes.viz} ref={barGoalsRef} style={{ height: 450 }} />
    </>
  );
};

BarGoals.propTypes = {
  classes: PropTypes.object.isRequired,
};

BarGoals.defaultProps = {
};

export default injectSheet(styles)(BarGoals);
